export class SavedColumnBinding {
    SavedColumnId: number;
    LocalSystemName: string;

    constructor(savedColumnId: number, localSystemName: string) {
        this.SavedColumnId = savedColumnId;
        this.LocalSystemName = localSystemName;
    }
}
